import { Event } from '../event';

export class DocumentScrollEvent implements Event {
    constructor(
        public scrollTop: number = 0,
        public scrollBottom: number = 0
    ) {}
}
